import CurrencyItem from "../type/currency-item";
import Price from "../type/price";
import { sumLimitForSellNachweis } from "../utils/enums/CONSTANTS";
//import console from "../utils/functions/console";
import { BasketStorage } from "./BasketStorage";

export class SortenBasket extends BasketStorage {
  constructor() {
    super();
    this.counter = 0;
    this.sumNetto = Price.create(0);
    this.sumitemsPrice = 0; // needed for binding, just a copy of sumNetto.getPrice()
    this.shippingMax = Price.create(12.5); // fix value for disclainer
    this.hasFilialChoice = true;
    this.gebuehren = {};
  }

  addItem(currency) {
    if (this.locked) return;
    let itm;
    itm = currency.clone("itm" + this.counter);
    itm.basket = this;
    this.items.push(itm);
    this.counter++;
    this.updateSum();
  }

  changeDues(item, due) {
    item.changedDue = due;
    if (!this.hasDues) {
      this.hasDues = true;
    }
    this.updateSum();
  }

  checkFilialeOption() {

    //set doShip again
    if (this.isAnkaufShop) {
      this.doShip = "no";
    } 

    this.calcShippingChoice();
    this.hasFilialChoice =
      this.hasFilialen() &&
      (!this.hasShippingChoice || this.doShip === "no");
    if (!this.hasFilialChoice && this.hasShippingChoice) this.setDoShip("yes");
    if (!this.hasFilialChoice) this.selectedFiliale = null;
  }

  getWarenkorbPos() {
    if (!this.orderDataForOrder || !Array.isArray(this.orderDataForOrder.sortenWarenkorbPos)) return [];
    return this.orderDataForOrder.sortenWarenkorbPos;
  }

  showNachweisWarning() {
    return this.sum.getPrice() > sumLimitForSellNachweis;
  }

  isTooHighForSell() {
    // ✅ Sorten Ankauf: only consider role-based numericLimit
    if (this.isAnkaufShop) {
      if (this.numericLimit === null || isNaN(this.numericLimit)) {
        return false;
      }
      return this.sum.getPrice() > this.numericLimit;
    }   
  }
 
  updateSum() {
    // update Items
    this.items.forEach(item => {
      if (this.hasDues && item.getPrice().getPrice() > 0) {
        if (item.changedDue) {
          item.setPositionDues(item.changedDue.getPrice());
        } else {
          item.setPositionDues(this.duesAmount);
        }
      }
      item.positionSum = item.price.clone().add(item.positionDues);
    });
    this.sumNetto = this.items.reduce((prev, item) => prev.add(item.price), new Price(0));

    this.sum = this.items.reduce((prev, item) => prev.add(item.positionSum), new Price(0));

    this.positionDuesSum = this.items.reduce((prev, item) => {
      if (this.hasDues && item.getPrice().getPrice() > 0) {
        prev.add(item.positionDues);
      }
      return prev;
    }, new Price(0));

    this.sumitemsPrice = this.sumNetto.getPrice();
    // evaluating & adding shipping costs
    this.checkSum = this.sum.clone().addNumber(this.shippingCosts);
    if (this.isDirectOrder()) {
      this.shipping = Price.create(this.shippingCosts);
      this.sum.add(this.shipping);
    } else {
      this.shipping = Price.create(0);
    }
    // evaluating dues
    if (this.hasDues) {
      if (this.items.length === 0) {
        this.dues.setPrice(0);
      } else {
        this.dues.setPrice(this.positionDuesSum.getPrice());
      }
    }
    this.calcShippingChoice();
    this.checkFilialeOption();
  }

  getEnthalteneProvision() {
    let gesamtProvision = Price.create(0);
    const warenkorbPos = this.getWarenkorbPos();
    for (let warenkorbItem of warenkorbPos) {
      let item = this.findInListByProp(this.items, "iso", warenkorbItem.iso.toLowerCase());
      gesamtProvision.add(this.getImItemEnthalteneProvision(item));
    }
    return gesamtProvision;
  }

  setMasterData(data) {
    const gebuehren = (data || {}).gebuehren || {};
    this.setGebuehren(gebuehren);

    this.recalcLimits();

    this.shippingCosts = Number(this.gebuehren.soDvBetrag);
    this.editCondition = String(this.gebuehren.konditionKz).toUpperCase() === "J";

    if (Number(this.gebuehren.soProz) !== 0.0) {
      this.duesPercentage = Number(this.gebuehren.soProz);
    } else {
      this.duesPercentage = 0;
    }

    if (Number(this.gebuehren.soBetrag) !== 0.0) {
      this.duesAmount = Number(this.gebuehren.soBetrag);
      this.hasDues = true;
    } else {
      this.duesAmount = 0;
      this.hasDues = false;
    }

    this.setBaseMasterData(data);    

    //Beim Ankauf wird automatisch die erste Filiale (Hauptstelle) zurückgegeben
    if (this.hasFilialen() && this.isAnkaufShop) this.selectedFiliale = this.filialen[0];
    if (!this.hasFilialen() && !this.isAnkaufShop) {
      this.doShip = "yes";
    }
  }

  recalcLimits() {
    // ✅ resolve orderLimit via shared base logic
    const numericLimit = this.getOrderLimit();
    this.numericLimit = numericLimit;

    const backendMaxShipment = Number(this.gebuehren.soDvMaxBetrag);
    const backendMaxSum = Number(this.gebuehren.soFvMaxBetrag);

    // ✅ apply minimum logic (same as Edelmetall)
    this.maxShipment =
      numericLimit !== null && !isNaN(numericLimit)
        ? Math.min(backendMaxShipment, numericLimit)
        : backendMaxShipment;

    if (this.isAnkaufShop) {
      this.maxSum = numericLimit;
    } else {
      this.maxSum =
        numericLimit !== null && !isNaN(numericLimit)
          ? Math.min(backendMaxSum, numericLimit)
          : backendMaxSum;
    }
  }

  updateData({ listeSorte }) {
    if (!Array.isArray(listeSorte)) return;
    this.items = this.items.map(item => {
      const props = listeSorte.find(i => i.kennziffer === item.kennziffer);
      if (!props) return item;
      const stueckelung = String(props.stueckelungen)
        .split(",")
        .filter((d) => !!d)
        .map((d) => Number(d))
        .filter((d) => !isNaN(d))
        .sort((a, b) => {
          if (a === b) return 0;
          return a < b ? -1 : 1;
        });

      const newItem = CurrencyItem.create({
        kennziffer: item.kennziffer,
        id: item.iso + item.kennziffer,
        name: props.bezeichnung,
        symbol: item.symbol,
        iso: item.iso,
        rate: props.kurs,
        denomination: stueckelung,
        innenProvision: props.innen_provision,
        minDenomination: props.kleinsteStueckelung,
        positionDues: 0,
        positionSum: 0,
        produktInfo: props.produktInfo,
      });
      newItem.setAmount(item.amount);
      newItem.selectedIso = "eur";
      newItem.setSelectedDenomination(item.selectedDenomination);
      newItem.showEuro();
      newItem.basket = this;
      return newItem;
    });
    this.updateSum();
  }

  checkDirectBestellung() {
    if (this.isDirectOrder() && this.doShip === "yes") {
      return "ja";
    } else if (!this.isDirectOrder() && this.doShip === "no") {
      return "nein";
    }
  }

  resetWarenkorb() {
    this.sumNetto = Price.create(0);
    this.resetBaseWarenkorb();
  }

  toJSONForCart(sessionId, produktkatalogTimestamp, kundenId) {
    // structure: see if6RequestSortenBestellung.json
    let data = {
      sortenWarenkorb: {
        sessionId: sessionId,
        netto: this.sumNetto.getPrice(),
        steuer: 0,
        brutto: this.sum.getPrice(),
        versandkosten: this.shipping.getPrice(),
        direktbestellung: this.isDirectOrder() ? "ja" : "nein",
        gebuehren: this.positionDuesSum.getPrice(),
        summe: this.sum.getPrice(),
        produktkatalogTimestamp: produktkatalogTimestamp
      },
      sortenWarenkorbPos: this.items.map(i => i.toJSONForCart()),
      kundenId: kundenId
    };
    return data;
  }

  toJSONForOrder(sessionId, timestamp, angebotsNr) {
    let data = {
      sortenWarenkorb: {
        sessionId: sessionId,
        brutto: this.sum.getPrice(),
        netto: this.sumNetto.getPrice(),
        steuer: 0,
        versandkosten: this.shipping.getPrice(),
        direktbestellung: this.isDirectOrder() ? "ja" : "nein",
        gebuehren: this.positionDuesSum.getPrice(),
        summe: this.sum.getPrice(),
        produktkatalogTimestamp: timestamp
      },
      order: {
        netto: this.sumNetto.getPrice(),
        steuer: 0,
        brutto: this.sum.getPrice(),
        versandkosten: this.shipping.getPrice(),
        direktbestellung: this.isDirectOrder() ? "ja" : "nein",
        gebuehren: this.positionDuesSum.getPrice(),
        summe: this.sum.getPrice(),
        produktkatalogTimestamp: timestamp,
        angebotsNr: angebotsNr || "",
      },
      sortenWarenkorbPos: this.items.map(i => i.toJSONForOrder()),
      sortenWarenkorbPosRequest: this.items.map(i => i.toJSONForOrderRequest())
    };
    return data;
  }

  rebuildForApproval(data) {
    // check if there are products in basket
    if (data.listSortenWarenkorbPos.length === 0) {
      this.sum = Price.create(0);
      this.sumNetto = Price.create(0);
      this.sumitemsPrice = 0;
      this.sumBruttoPrice = 0;
      this.items = [];
      this.dirty = false;
      this.locked = false;
      this.setError("ein technisches Problem ist aufgetreten");
      return false;
    }

    // dirty check: the length of the sent basket should at least equal the length of our Items
    if (this.items.length !== data.listSortenWarenkorbPos.length) {
      this.setError('ERROR: The confirmed basket did not match the sent basket.');
    }

    let i, dItem, wItem;
    // merging delta into sent basket
    for (i = 0; i < data.listSortenWarenkorbPos.length; i++) {
      wItem = data.listSortenWarenkorbPos[i];
      dItem = this.findInListByProp(data.listSortenWarenkorbDelta, "bestellpositionId", wItem.position);
      if (dItem != null) {
        //set basket to dirty.
        this.dirty = true;
        this.items[wItem.position].recreate({ rate: dItem.verkaufskursNeu, price: wItem.euro, dirty: true });
        this.updateSum();
      } else {
        this.items[wItem.position].dirty = false;
      }
    }
  }

  restoreData(data) {
    this.restoreBaseData(data);
    this.gebuehren = data.gebuehren;
  }

  setDoShip(doShip) {
    const triggerUpdate = this.doShip !== doShip;
    switch (doShip) {
      case "yes":
      case "no":
        this.doShip = doShip;
        break;
      default:
        break;
    }
    if (this.doShip !== "no") this.selectedFiliale = null;
    if (triggerUpdate) this.updateSum();
  }

  calcInnenProvision() {
    let innenProvision = 0;
    const netto = Number(this.sumNetto.getPrice());
    if (this.gebuehren.provisionRate !== null) {
      innenProvision = netto * Number(this.gebuehren.provisionRate) / 100;
    }
    return innenProvision;
  }

  setGebuehren(newGebuehren) {
    this.gebuehren = { ...newGebuehren };
    this.shippingCosts = Number(this.gebuehren.soDvBetrag);
    this.gebuehren.provisionRate = this.gebuehren.soProvisionRate;
    delete this.gebuehren.emProvisionZusatzKz;
    this.provisionRate = Number(this.gebuehren.provisionRate);
    if (window.localStorage) localStorage.setItem("gebuehren", JSON.stringify(this.gebuehren));
  }

  getImItemEnthalteneProvision(item) {
    if (!item || !item.price) return Price.create(0);

    // console.info("item.rate: " + item.rate);
    // console.info("duesPercentage: " + this.duesPercentage);

    let originalRate;
    let relativeKursaenderung;

    originalRate = Math.round(item.rate * (1 + this.duesPercentage / 100) * 10000) / 10000;
    // console.info("originalRate: " + originalRate);

    const originalPrice = Math.round(item.amount / originalRate * 1000000) / 1000000;
    const price = Math.round(item.amount / item.rate * 1000000) / 1000000;
    
    // console.info("originalPrice: " + originalPrice);
    // console.info("item.price: " + price);

    if(this.isAnkaufShop) {
      relativeKursaenderung =  Math.round( (originalPrice - price) * 100) / 100;
      // console.info("ankauf - relativeKursaenderung: " + relativeKursaenderung);
    } else {
      relativeKursaenderung = Math.round( (price - originalPrice) * 100) / 100;
      // console.info("verkauf - relativeKursaenderung: " + relativeKursaenderung);
    }
    let provision = !isNaN(item.innenProvision) ? item.innenProvision : this.provisionRate;
    // console.info("innen-provision proz: " + provision);

    let innenProvision = Math.round(originalPrice * provision)/100; 
    // console.info("innen-provision: " + innenProvision);
    // console.info("provision-summe: " + (innenProvision + relativeKursaenderung));

    return Price.create(innenProvision + relativeKursaenderung);
  }
}
